var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isloading),expression:"isloading"}],staticClass:"loader"},[_c('img',{attrs:{"src":require("../../assets/loader.png"),"alt":"Carregando..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }